import {Routes} from '@angular/router';
import {AuthenticatedComponent} from './authenticated/authenticated.component';
import {routes as authenticatedRoutes} from './authenticated/authenticated.routes';
import {routes as authRoutes} from './auth/auth.routes';
import {AuthComponent} from './auth/auth.component';
import {isAuthenticatedGuard} from './guards/is-authenticated-guard';
import {hasTwoFactorAuthEnabledGuard} from './guards/has-two-factor-auth-enabled-guard';

export const routes: Routes = [
  {
    path: 'auth',
    component: AuthComponent,
    children: authRoutes,
  },
  {
    path: '',
    component: AuthenticatedComponent,
    canActivate: [hasTwoFactorAuthEnabledGuard, isAuthenticatedGuard],
    children: authenticatedRoutes,
  },
];
